import React, { useEffect } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';

import selectActualFilterItems from './selectActualFilterItems';
import AppIcon from '../../AppIcon';

import styles from './Filter.scss';


const cx = classNames.bind(styles);

type Props = {
  filter: Array<string>,
  baseUrl: string,
  activeItem: string,
  studentId: number,
  className?: string,
  onInvalidActiveItem?: () => void,
}

const Filter = ({ filter, baseUrl, activeItem, studentId, className, onInvalidActiveItem }: Props) => {
  const actualFilterItems = useSelector(state => selectActualFilterItems(state, { studentId, filter }));

  const invalidActiveItem = !actualFilterItems.find(({ string }) => activeItem === string);

  useEffect(() => {
    if (invalidActiveItem && onInvalidActiveItem) {
      onInvalidActiveItem();
    }
  }, [invalidActiveItem]); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div className={cx(styles.root, className)}>
      {actualFilterItems.map(item => (
        <Link
          key={item.string}
          className={cx({ item: true, active: item.string === activeItem })}
          to={`${baseUrl}/${item.string}`}
        >
          <div className={styles.iconContainer}>
            <AppIcon
              string={item.string}
              className={cx(styles.icon, { active: item.string === activeItem })}
            />
          </div>
          <div>
            {item.title}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Filter;
